module.exports = __webpack_public_path__ + "img/watts.a19a8193.png";